import React from 'react';
import { TextField } from '@mui/material';

const CustomTextField = ({ label, value, onChange, sx, autoComplete, ...rest }) => {
    const defaultSx = {
        '& .MuiInputBase-input': { color: '#fff' },
        '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
        '& .MuiInputLabel-root.Mui-focused': { color: '#fff' },
        '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.23)' },
            '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 0.5)' },
            '&.Mui-focused fieldset': { borderColor: '#fff' }
        }
    };

    return (
        <TextField
            label={label}
            value={value}
            onChange={onChange}
            fullWidth
            variant="outlined"
            autoComplete={autoComplete || "off"}
            sx={{ ...defaultSx, ...sx }}
            {...rest}
        />
    );
};

export default CustomTextField;